import {useEffect} from 'react';

import {buildUserTrackingContext} from './buildTrackingContext';
import {setUserTrackingContext} from './trackingContext';
import {useStoreContext} from '~/store/useStoreContext';

export function TrackingContextSync() {
  const [state] = useStoreContext();

  useEffect(() => {
    setUserTrackingContext(buildUserTrackingContext(state));
  }, [
    state,
  ]);

  return null;
}
